import RequestAbstract from "./RequestAbstract";
import helper from "actions/helper";

import dates from "actions/helper/dates";

export default class Messages extends RequestAbstract {
    get link() {
        return this.links.messages;
    }

    async sendClientSms(clientId, text, afterMins = 0) {
        const notifyDateTime = dates.toUtc(dates.addMins(null, afterMins), 1);

        return this.add({
            clientId,
            text,
            notifyDateTime,
            title: null,
            messageType: "SMS"
        });
    }

    async getMessagesByClientId(clientId, from, to) {

        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "createdTime", op: ">", value: helper.date.toStr(from.setHours(0, 0)) },
            { field: "createdTime", op: "<", value: helper.date.toStr(to.setHours(23, 59)) },
        ];
        return await this.getAllFiltered([arr]);

    }
}
